import { useContext, useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { DashboardContext } from 'contexts/DashboardContext';
import Container from 'components/Container';
import Loader from 'components/Loader';
import Card from 'components/Card';
import Pie from './Charts/Pie';
import styles from './styles';

const App = () => {
  const { dashData, getLoading, getDashboard } = useContext(DashboardContext);

  const gridProps = { ...styles?.grid, item: true, md: 12 };

  useEffect(() => {
    getDashboard();
  }, []);

  return (
    <Container>
      {getLoading && <Loader />}
      <Grid container spacing={5} display={getLoading ? 'none' : 'flex'}>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h4">Produtos</Typography>
            </Grid>
            <Grid {...gridProps} lg={4}>
              <Card title="Produtos por status" style={styles?.card}>
                <Pie values={dashData?.produto?.por_status} />
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h4">Entidades</Typography>
            </Grid>
            <Grid {...gridProps} lg={4}>
              <Card title="Entidades por status" style={styles?.card}>
                <Pie values={dashData?.entidade?.por_status} />
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default App;
